module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "gallery-image-container"
  }, [_c('gallery', {
    attrs: {
      "images": _vm.files,
      "index": _vm.index
    },
    on: {
      "close": function($event) {
        _vm.index = null
      }
    }
  }), _c('div', {
    staticClass: "image-container clearfix"
  }, _vm._l((_vm.files), function(image, imageIndex) {
    return _c('div', [_c('div', {
      staticClass: "image",
      style: ({
        backgroundImage: 'url(' + image.thumbnail + ')'
      }),
      on: {
        "click": function($event) {
          _vm.openImage(imageIndex)
        }
      }
    }), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(image.file_name))]), _c('span', {
      staticClass: "btn-link download",
      on: {
        "click": function($event) {
          _vm.downloadImage(image.path)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pos.file-gallery.download')))])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81ae5acc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/file-gallery/FileGallery.vue
// module id = 2075
// module chunks = 1